export default {
  mounted(el, binding, vnode) {
    const maxClicks = binding.value?.maxClicks || 5;
    const interval = binding.value?.interval || 3000; // Интервал времени для подсчета кликов
    const cooldown = binding.value?.cooldown || 3000; // Длительность состояния загрузки при превышении лимита
    const loaderClass = binding.value?.loaderClass || 'element-load-limit'; // Имя класса загрузки

    let clickCount = 0;
    let startTime = null;

    const clickHandler = (event) => {
      const currentTime = Date.now();

      // Инициализируем startTime при первом клике или после истечения интервала
      if (!startTime || currentTime - startTime > interval) {
        startTime = currentTime;
        clickCount = 0;
      }

      clickCount++;

      if (clickCount > maxClicks) {
        // Превышен лимит кликов в заданном интервале
        event.stopImmediatePropagation();
        event.preventDefault();

        activateLoadingState();

        if (typeof binding.value?.onLimitExceeded === 'function') {
          binding.value.onLimitExceeded();
        }

        setTimeout(() => {
          deactivateLoadingState();
          clickCount = 0;
          startTime = null;
        }, cooldown);
      }
    };

    const activateLoadingState = () => {
      el.disabled = true;

      if (vnode.componentInstance && 'isLoading' in vnode.componentInstance) {
        vnode.componentInstance.isLoading = true;
      } else {
        el.classList.add(loaderClass);
      }
    };

    const deactivateLoadingState = () => {
      el.disabled = false;

      if (vnode.componentInstance && 'isLoading' in vnode.componentInstance) {
        vnode.componentInstance.isLoading = false;
      } else {
        el.classList.remove(loaderClass);
      }
    };

    el.addEventListener('click', clickHandler);
    el.__rateLimitHandler__ = clickHandler;
  },
  unmounted(el) {
    el.removeEventListener('click', el.__rateLimitHandler__);
    delete el.__rateLimitHandler__;
  },
};
